import React from "react";
import Input, { INPUT_VALUE_TYPES } from "../BaseControls/Input";
import ControlTemplate from "../BaseControls/ControlTemplate";
import { controlPropTypes } from "../formhelpers";
import alertAndRefocusBuilder
    from "lib/common/descriptorcontrols/BaseControls/utils/alertAndRefocusBuilder";

export default function Text(props) {
    return (
        <ControlTemplate {...props} className="decimal-field">
            <Input
                {...props}
                valueType={INPUT_VALUE_TYPES.DECIMAL}
                onIllegal={alertAndRefocusBuilder(props)}
            />
        </ControlTemplate>
    );
}

Text.propTypes = controlPropTypes();



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/DecimalField/text.js